import React from 'react'
import { Stack } from '@fluentui/react'
import { ShieldLockRegular } from '@fluentui/react-icons'
import styles from './Unauthorized.module.css'

const Unauthorized: React.FC = () => {
  return (
    <div className={styles.container}>
      <Stack className={styles.content} horizontalAlign="center" verticalAlign="center">
        <ShieldLockRegular className={styles.icon} />
        <h1 className={styles.title}>Not Authenticated</h1>
        <p className={styles.message}>You are not authenticated. Access to this application is restricted.</p>
      </Stack>
    </div>
  )
}

export default Unauthorized
